import styled from 'styled-components';

export default {
    OutlinedButton: styled.a.attrs({ className: 'button-outlined' })`
        padding-left: 39px;
        padding-right: 39px;
        padding-top: 14px;
        padding-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #E50000;
        background-color: inherit;
        color:#E50000;
        border-radius: 50px;
        font-family: Toyota Display;
        margin: auto;
        font-size: 15px;
        grid-column-start: 1;
        grid-column-end: 3;
        width: 100%;
        box-sizing: border-box;
        margin-top: 17px;
        @media (max-width: 320px) {
            padding: 14px 30px 16px;
        }
        @media (min-width: 700px) {
            padding: 15px 24px 16px;
            margin: 0;
            max-width: ${props => props.status ? '250px' : '280px'};
            margin-bottom: 210px;
            max-height: 50px;
        }
    `,
};
